import { __isKnytElementDefinition } from "./constants.js";
export function isElementDefinition(value) {
    return (typeof value === "function" &&
        __isKnytElementDefinition in value &&
        value[__isKnytElementDefinition] === true);
}
